import React, { Component } from 'react';
import NumberFormat from 'react-number-format';
import WarningMessage from 'components/WarningMessage';
import styles from './ProgramType.css';
import Option from './Option';
import PointRule from './PointRule';
import ItemRule from './ItemRule';
import { MOBILE_APP_VERSION_WARNING } from '../../../constants';

class ProgramType extends Component {
  constructor(props) {
    super(props);
    this.state = this._initialState();
  }

  render() {
    const detailPro = this.props.loyaltySubscription.subscriptionDetail[
      'Loyalty Pro'
    ];
    const { isDisabledNext, earningRuleType } = this.state;
    return (
      <div className="top20">
        <p className={styles['action-label']}>Choose a Loyalty Program type</p>
        <div className={`row ${styles['program-type-row']}`}>
          <div className={`${styles['program-type']}`}>
            <div
              className={`${
                earningRuleType === 'SPENDING' ? styles.active : ''
              } ${styles.program} cursor-pointer`}
            >
              <Option
                img={require('assets/images/rp.png')}
                title="Gain points from total Rp. spent"
                body="Customers gain points for a certain amount of money they spend in one transaction."
                isDisabled={false}
                earningRuleType="SPENDING"
                onClick={this._onClickOption}
              />
            </div>
          </div>
          <div
            className={`${styles['program-type']} ${styles['program-item']}`}
          >
            {detailPro.is_active && (
              <div
                className={`${
                  earningRuleType === 'ITEM' ? styles.active : ''
                } ${styles.program} cursor-pointer`}
              >
                <Option
                  img={require('assets/images/groceries.png')}
                  title="Gain points from buying item"
                  body="Customers gain points by purchasing specific item or any item in a category.     "
                  isDisabled={false}
                  earningRuleType="ITEM"
                  onClick={this._onClickOption}
                />
              </div>
            )}
            {!detailPro.is_active && (
              <div
                className={`${styles.disabled} ${styles.program} cursor-not-allowed`}
              >
                <Option
                  img={require('assets/images/groceries.png')}
                  title="Gain points from buying item"
                  body="Customers gain points by purchasing specific item or any item in a category.     "
                  isDisabled={!detailPro.is_active}
                  earningRuleType="ITEM"
                  onClick
                />
              </div>
            )}
            {!detailPro.is_active && (
              <img
                src={require('assets/images/pro-icon.png')}
                className={styles['corner-icon']}
              />
            )}
          </div>
        </div>
        <div className={`${styles['earning-rule-details']}`}>
          {earningRuleType === 'SPENDING' && (
            <PointRule
              spendingAmount={this.props.spendingAmount}
              pointFromSpendingAmount={this.props.pointFromSpendingAmount}
              setSpendingAmount={this.props.setSpendingAmount}
              setPointFromSpendingAmount={this.props.setPointFromSpendingAmount}
              setDisabledNext={this._setDisabledNext}
              onFinish={this.props.onFinish}
            />
          )}
          {earningRuleType === 'ITEM' && (
            <ItemRule
              selectedItemRuleType={this.state.selectedItemRuleType}
              itemRuleTypes={this.state.itemRuleTypes}
              pointFromBuyingItem={this.props.pointFromBuyingItem}
              setPointFromBuyingItem={this.props.setPointFromBuyingItem}
              onSelectItemRuleType={this._onSelectItemRuleType}
              earningRuleItems={this.props.itemRules || []}
              setEarningRuleItems={this.props.setItemRules}
              setDisabledNext={this._setDisabledNext}
            />
          )}
        </div>

        <div className={`row  ${styles['program-new-member']}`}>
          <div className={`col-md-12 ${styles['program-new-member-label']}`}>
            Offer new member points to join loyalty program (Optional)
          </div>
          <div
            className={`col-md-6 ${styles['wrapped-input']} ${
              styles['program-new-member-points']
            }`}
          >
            <NumberFormat
              className="form-control form-control-success"
              value={this.props.newMemberPoint}
              onChange={this._onChangeNewMemberPoint}
              suffix=" Points"
              placeholder="0 Points"
              thousandSeparator="."
              decimalPrecision={0}
              decimalSeparator=","
              allowNegative={false}
            />
          </div>
        </div>

        {earningRuleType === 'ITEM' && (
          <div className={styles['app-version-warning']}>
            <WarningMessage
              message={MOBILE_APP_VERSION_WARNING}
              iconStyle={`circle`}
            />
          </div>
        )}

        <div className="top20">
          <button
            style={{ color: `${isDisabledNext ? '' : '#3e8acc'}` }}
            className="btn btn-default pull-right"
            onClick={this._onClickNext}
            disabled={isDisabledNext}
          >
            Next
          </button>
        </div>
      </div>
    );
  }

  _onClickNext = e => {
    e.stopPropagation();
    this.props.onFinish();
  };

  _initialState = () => {
    const itemRuleTypes = {
      item: 'ITEM',
      category: 'CATEGORY',
      itemVariant: 'ITEM_VARIANT',
    };
    const { itemRules } = this.props;
    let selectedItemRuleType = itemRuleTypes.item;
    if (itemRules && itemRules.length > 0) {
      selectedItemRuleType = itemRules[0].type;
    }
    return {
      earningRuleType: this.props.earningRuleType,
      isDisabledNext: false,
      itemRuleTypes,
      selectedItemRuleType,
      originalEarningRuleItems: this.props.itemRules,
    };
  };

  _onClickOption = earningRuleType => {
    this.props.setEarningRuleType(earningRuleType);
    this.setState({ earningRuleType });
  };

  _onChangeNewMemberPoint = (e, rawPoint) => {
    const maximum = 999999999999;
    if (rawPoint > maximum) {
      rawPoint = this.props.newMemberPoint;
    }

    if ($.isNumeric(rawPoint)) {
      rawPoint = parseInt(rawPoint);
    }

    this.props.setNewMemberPoint(rawPoint);
  };

  _setDisabledNext = isDisabledNext => {
    this.setState({ isDisabledNext });
  };

  _onSelectItemRuleType = itemRuleType => {
    const { originalEarningRuleItems } = this.state;
    if (
      originalEarningRuleItems &&
      originalEarningRuleItems.length > 0 &&
      itemRuleType === originalEarningRuleItems[0].type
    ) {
      this.props.setItemRules(originalEarningRuleItems);
    } else {
      this.props.setItemRules([]);
      this._setDisabledNext(true);
    }
    this.setState({ selectedItemRuleType: itemRuleType });
  };
}

export default ProgramType;
